
import { useMutation } from "@tanstack/react-query";
import axios from "../../lib/axios";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";



export const usePostVisit = () => {
    return useMutation({
        mutationKey: ["postvisit"],
        mutationFn: async () => {
            const response = await axios.post("v2/visit");
            return response.data;
        }
    });
}

export const useGetVisitData = () => {
    return useQuery({
        queryKey: ["getvisit"],
        queryFn: async () => {
            const response = await axios.post("v2/daily-visit");
             return response.data;
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch data");
        },
    });
};